import { render, staticRenderFns } from "./RedeemGameRecords.vue?vue&type=template&id=40d01fce&scoped=true&"
import script from "./RedeemGameRecords.vue?vue&type=script&lang=js&"
export * from "./RedeemGameRecords.vue?vue&type=script&lang=js&"
import style0 from "./RedeemGameRecords.vue?vue&type=style&index=0&id=40d01fce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d01fce",
  null
  
)

export default component.exports